import React from "react";
import { Form, ControlLabel, FormGroup, FormControl, Row, Radio, Col } from "react-bootstrap";

class ClubRegistrationThirdStep extends React.Component {
    constructor() {
        super();
        this.state = {
      numberOfTeams: 2,
    };
        this.onSubmit = this.onSubmit.bind(this);
    this.clubCategoryCode = "Amateur";
        this.clubCommitmentCode = 1;
        this.monoMulti = true;
        this.monoTeamId = "";
        this.numberOfTeams = 2;
        this.team1Id = "";
        this.team2Id = "";
        this.team3Id = "";
        this.team4Id = "";
        this.team5Id = "";
        this.team6Id = "";
        this.team7Id = "";
        this.team8Id = "";
        this.team9Id = "";
        this.team10Id = "";
        this.team11Id = "";
        this.team12Id = "";
        this.team13Id = "";
        this.team14Id = "";
        this.team15Id = "";
        this.team16Id = "";
        this.team17Id = "";
        this.team18Id = "";
        this.team19Id = "";
        this.team20Id = "";
        this.team21Id = "";
        this.team22Id = "";
        this.team23Id = "";
        this.team24Id = "";
        this.team25Id = "";
        this.team26Id = "";
        this.team27Id = "";
        this.team28Id = "";
        this.team29Id = "";
        this.team30Id = "";
        this.team31Id = "";
        this.team32Id = "";
        this.team33Id = "";
        this.team34Id = "";
        this.team35Id = "";
        this.team36Id = "";
        this.team37Id = "";
        this.team38Id = "";
        this.team39Id = "";
        this.team40Id = "";
        this.handleChange = this.handleChange.bind(this);
        this.handleRadioChangeWithShowHide = this.handleRadioChangeWithShowHide.bind(this);
        this.handleNumberOfTeamsChange = this.handleNumberOfTeamsChange.bind(this);
        this.returnMultiTeams = this.returnMultiTeams.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);
    this.setDataOnModel = this.setDataOnModel.bind(this);
    }
    componentDidMount() {
        this.props.onRef(this);
    this.setDefaultValues();
    }
    setDefaultValues() {
        this.clubCategoryCode = this.props.clubRegistrationModel.clubCategoryCode;
    this.props.setRadiofieldChecked("thirdStageForm", "clubCategoryCode", this.clubCategoryCode);

        this.clubCommitmentCode = this.props.clubRegistrationModel.clubCommitmentCode;
    this.props.setRadiofieldChecked("thirdStageForm", "clubCommitmentCode", this.clubCommitmentCode);

        this.monoMulti = this.props.clubRegistrationModel.monoMulti;
    this.props.setRadiofieldChecked("thirdStageForm", "monoMulti", this.monoMulti);
    this.handleRadioChangeWithShowHide(null, this.monoMulti, "monoMulti");
        this.monoTeamId = this.props.clubRegistrationModel.monoTeamId;
        this.numberOfTeams = this.props.clubRegistrationModel.numberOfTeams;

        this.team1Id = this.props.clubRegistrationModel.team1Id;
        this.team2Id = this.props.clubRegistrationModel.team2Id;
        this.team3Id = this.props.clubRegistrationModel.team3Id;
        this.team4Id = this.props.clubRegistrationModel.team4Id;
        this.team5Id = this.props.clubRegistrationModel.team5Id;
        this.team6Id = this.props.clubRegistrationModel.team6Id;
        this.team7Id = this.props.clubRegistrationModel.team7Id;
        this.team8Id = this.props.clubRegistrationModel.team8Id;
        this.team9Id = this.props.clubRegistrationModel.team9Id;
        this.team10Id = this.props.clubRegistrationModel.team10Id;
        this.team11Id = this.props.clubRegistrationModel.team11Id;
        this.team12Id = this.props.clubRegistrationModel.team12Id;
        this.team13Id = this.props.clubRegistrationModel.team13Id;
        this.team14Id = this.props.clubRegistrationModel.team14Id;
        this.team15Id = this.props.clubRegistrationModel.team15Id;
        this.team16Id = this.props.clubRegistrationModel.team16Id;
        this.team17Id = this.props.clubRegistrationModel.team17Id;
        this.team18Id = this.props.clubRegistrationModel.team18Id;
        this.team19Id = this.props.clubRegistrationModel.team19Id;
        this.team20Id = this.props.clubRegistrationModel.team20Id;
        this.team21Id = this.props.clubRegistrationModel.team21Id;
        this.team22Id = this.props.clubRegistrationModel.team22Id;
        this.team23Id = this.props.clubRegistrationModel.team23Id;
        this.team24Id = this.props.clubRegistrationModel.team24Id;
        this.team25Id = this.props.clubRegistrationModel.team25Id;
        this.team26Id = this.props.clubRegistrationModel.team26Id;
        this.team27Id = this.props.clubRegistrationModel.team27Id;
        this.team28Id = this.props.clubRegistrationModel.team28Id;
        this.team29Id = this.props.clubRegistrationModel.team29Id;
        this.team30Id = this.props.clubRegistrationModel.team30Id;
        this.team31Id = this.props.clubRegistrationModel.team31Id;
        this.team32Id = this.props.clubRegistrationModel.team32Id;
        this.team33Id = this.props.clubRegistrationModel.team33Id;
        this.team34Id = this.props.clubRegistrationModel.team34Id;
        this.team35Id = this.props.clubRegistrationModel.team35Id;
        this.team36Id = this.props.clubRegistrationModel.team36Id;
        this.team37Id = this.props.clubRegistrationModel.team37Id;
        this.team38Id = this.props.clubRegistrationModel.team38Id;
        this.team39Id = this.props.clubRegistrationModel.team39Id;
        this.team40Id = this.props.clubRegistrationModel.team40Id;
        this.setState({
      numberOfTeams: this.numberOfTeams,
    });
        // this.forceUpdate()
    }

    handleChange(e) {
    if (e.target.type === "text" || e.target.type === "radio") {
            this[e.target.name] = e.target.value;
    } else if (e.target.type === "select-one") {
            // this[e.target.name] = {
            //     id: Number(e.target.value),
            //     description: e.target.selectedOptions[0].label,
            // };
            this[e.target.name] = Number(e.target.value)

        }
    }

    onSubmit(model) {
    this.setDataOnModel(model);
        let isValid = model.thirdStageValidity();
        return isValid;
    }

    setDataOnModel(model) {
        model.setThirdStadiumData(
      this.clubCategoryCode,
      this.clubCommitmentCode,
      this.monoMulti,
            this.monoTeamId,
      this.numberOfTeams,
            this.team1Id,
            this.team2Id,
            this.team3Id,
            this.team4Id,
            this.team5Id,
            this.team6Id,
            this.team7Id,
            this.team8Id,
            this.team9Id,
            this.team10Id,
            this.team11Id,
            this.team12Id,
            this.team13Id,
            this.team14Id,
            this.team15Id,
            this.team16Id,
            this.team17Id,
            this.team18Id,
            this.team19Id,
            this.team20Id,
            this.team21Id,
            this.team22Id,
            this.team23Id,
            this.team24Id,
            this.team25Id,
            this.team26Id,
            this.team27Id,
            this.team28Id,
            this.team29Id,
            this.team30Id,
            this.team31Id,
            this.team32Id,
            this.team33Id,
            this.team34Id,
            this.team35Id,
            this.team36Id,
            this.team37Id,
            this.team38Id,
            this.team39Id,
            this.team40Id
    );
    }
    handleRadioChangeWithShowHide(e, checkedValue, name) {
        try {
            let fieldName = e ? e.target.name : name;
      let fieldValue = e ? e.target.value == "true" : checkedValue;

            this[fieldName] = fieldValue;

            let monoTeamNameFieldset = null;
      monoTeamNameFieldset = document.getElementsByClassName("monoTeamNameFieldset")[0];
      monoTeamNameFieldset.classList.toggle("hidden", !this[fieldName]);
            let multiTeamNameFieldset = null;
      multiTeamNameFieldset = document.getElementsByClassName("multiTeamNameFieldset")[0];
      multiTeamNameFieldset.classList.toggle("hidden", this[fieldName]);
        } catch (error) {
      console.log(error);
        }
    }
    handleNumberOfTeamsChange(e) {
        try {
            this[e.target.name] = Number(e.target.value);
            this.setState({
        numberOfTeams: Number(e.target.value),
      });
        } catch (error) {
      console.log(error);
        }
    }
    returnMultiTeams() {
        let i = 1,
      labelSelector = "",
      fieldName = "",
            fields = [];
        for (i; i <= this.state.numberOfTeams; i++) {
      labelSelector = i + ".";
            fieldName = "team" + i + "Id";
      fields.push(
        <Row key={fieldName} className="registrationMultiTeamRow">
          <FormGroup className="registerFormGroup" controlId={fieldName + "Text"}>
            <Col className="registerFieldLabel" componentClass={ControlLabel} lg={4} md={4} sm={4} xs={12}>
              {labelSelector + this.props.composingLabel("sportOauthLabel.teamName", "Team name")}
            </Col>
                    <Col lg={6} md={6} sm={6} xs={12} >
                            <FormControl className='registerField' componentClass="select"
                                name={fieldName}
                                onChange={this.handleChange}>
                                <option value={0}>{''}</option>
                                {this.props.teams.map(team => {
                                    console.log(team)
                                    return <option key={team.id} value={team.id}>{team.name}</option>
                                })}
                            </FormControl>
                    </Col>
                </FormGroup>
        </Row>
      );
        }
        return fields;
    }
    render() {
        let { composingLabel } = this.props;
        return (
      <Form name="thirdStageForm">
        <fieldset className="registrationFieldSet">
          <legend className="registerFieldsetLabel">{composingLabel("sportOauthLabel.clubCategory", "Club category")}</legend>
                    <Row className="show-grid">
            <FormGroup className="registerFormGroup" controlId="adminIsMainStadiumText">
              <Col componentClass={ControlLabel} lg={12} md={12} sm={12} xs={12} className="registerFieldLabel">
                {composingLabel("sportOauthLabel.selectClubCategory", "Please select club category")}
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="clubCategoryCodeRadioField">
                                <Col lg={4} md={4} sm={4} xs={4} >
                  <Radio type="radio" defaultChecked value={"Amateur"} name="clubCategoryCode" id="clubCategoryCodeRadios1" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.amateur", "Amateur")}
                  </Radio>
                                </Col>
                                <Col lg={4} md={4} sm={4} xs={4} >
                  <Radio type="radio" value={"SmiAmateur"} name="clubCategoryCode" id="clubCategoryCodeRadios2" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.semiProf", "Semi-Professional")}
                  </Radio>
                                </Col>
                                <Col lg={4} md={4} sm={4} xs={4} >
                  <Radio type="radio" value={"Prfssional"} name="clubCategoryCode" id="clubCategoryCodeRadios3" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.professional", "Professional")}
                  </Radio>
                                </Col>
                            </Col>
                        </FormGroup>
                    </Row>
                </fieldset>
        <fieldset className="registrationFieldSet">
          <legend className="registerFieldsetLabel">{composingLabel("sportOauthLabel.contractCommitment", "Contract Commitment")}</legend>
                    <Row className="show-grid">
            <FormGroup className="registerFormGroup" controlId="adminIsMainStadiumText">
              <Col componentClass={ControlLabel} lg={12} md={12} sm={12} xs={12} className="registerFieldLabel">
                {composingLabel("sportOauthLabel.selectPeriodOfCommitment", "Please select period of commitment")}
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="clubCommitmentCodeRadioField">
                                <Col lg={3} md={3} sm={6} xs={6} >
                                    <Radio
                                        type="radio" defaultChecked
                                        value={1} name="clubCommitmentCode" id="clubCommitmentCodeRadios1" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.oneYear", "ONE Year")}
                  </Radio>
                                </Col>
                                <Col lg={3} md={3} sm={6} xs={6} >
                                    <Radio
                                        type="radio"
                                        value={3} name="clubCommitmentCode" id="clubCommitmentCodeRadios2" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.threeYears", "THREE Years")}
                  </Radio>
                                </Col>
                                <Col lg={3} md={3} sm={6} xs={6} >
                                    <Radio
                                        type="radio"
                                        value={5} name="clubCommitmentCode" id="clubCommitmentCodeRadios3" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.fiveYears", "FIVE Years")}
                  </Radio>
                                </Col>
                                <Col lg={3} md={3} sm={6} xs={6} >
                                    <Radio
                                        type="radio"
                                        value={8} name="clubCommitmentCode" id="clubCommitmentCodeRadios4" onClick={(e) => this.handleChange(e)}>
                    {composingLabel("sportOauthLabel.eightYears", "EIGHT Years")}
                  </Radio>
                                </Col>
                            </Col>
                        </FormGroup>
                    </Row>
                </fieldset>
        <fieldset className="registrationFieldSet">
          <legend className="registerFieldsetLabel">{composingLabel("sportOauthLabel.numberOfTeams", "Number of team(s)")}</legend>
                    < Row className="show-grid" >
            <FormGroup className="registerFormGroup" controlId="adminIsMainStadiumText">
              <Col componentClass={ControlLabel} lg={12} md={12} sm={12} xs={12} className="registerFieldLabel">
                {composingLabel("sportOauthLabel.selectMonoMultiTeamSubscription", "Please select if mono or multi-team subscription", false)}
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="monoMultiRadioField">
                                <Col lg={6} md={6} sm={6} xs={6} >
                  <Radio type="radio" defaultChecked value={true} name="monoMulti" id="monoMultiRadios1" onClick={(e) => this.handleRadioChangeWithShowHide(e, "monoTeamName")}>
                    {composingLabel("sportOauthLabel.monoTeam", "Mono-team")}
                  </Radio>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6} >
                  <Radio type="radio" value={false} name="monoMulti" id="monoMultiRadios2" onClick={(e) => this.handleRadioChangeWithShowHide(e, "multiTeamName")}>
                    {composingLabel("sportOauthLabel.multiTeam", "Multi-team")}
                  </Radio>
                                </Col>
                            </Col>
                        </FormGroup>
                    </Row>
          <fieldset className="monoTeamNameFieldset">
                        <Row>
              <FormGroup className="registerFormGroup" controlId="monoTeamNameText">
                <Col className="registerFieldLabel" componentClass={ControlLabel} lg={4} md={4} sm={4} xs={12}>
                  {composingLabel("sportOauthLabel.monoTeamName", "Mono team name", false)}
                </Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' componentClass="select"
                                        name='monoTeamId'
                                        onChange={this.handleChange}>
                                        <option value={0}>{''}</option>
                                        {this.props.teams.map(team => {
                                            return <option key={team.id} value={team.id}>{team.name}</option>
                                        })}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Row>
                    </fieldset>
          <fieldset className="multiTeamNameFieldset hidden">
                        <Row >
              <FormGroup className="registerFormGroup" controlId="numberOfTeamsText">
                <Col className="registerFieldLabel" componentClass={ControlLabel} lg={4} md={4} sm={4} xs={12}>
                  {composingLabel("sportOauthLabel.numOfTeams", "Number of team(s)", false)}
                </Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl
                    className="registerField"
                                        type="number"
                    name="numberOfTeams"
                                        value={this.state.numberOfTeams}
                                        min={2}
                                        max={40}
                    onChange={(e) => this.handleNumberOfTeamsChange(e)}
                  />
                                </Col>
                            </FormGroup>
                        </Row>
                        {this.returnMultiTeams()}
                    </fieldset>
                </fieldset>
            </Form >
    );
    }
}

export default ClubRegistrationThirdStep;



// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationThirdStep.js